import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import CustomerSelector from "@main/customers/components/CustomerSelector";
import FeeSelector from "@main/fees/components/FeeSelector";
import { Pencil, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";
import GenderSelector from "./components/GenderSelector";

const config = {
  modelName: "pet",
  modelPluralName: "pets",
  endpoint: "pets",
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "name",
        label: "name",
        key: "name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "breed",
        label: "breed",
        key: "breed",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "passport",
        label: "passport",
        key: "passport",
        type: "string",
        show: true,
        allowOrder: true,
      }
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      // Name
      name: {
        type: "string",
        title: t("name"),
      },
      // Customer
      customer_id: {
        type: "number",
        title: t("customer"),
      },
      // Breed
      breed: {
        type: "string",
        title: t("breed"),
      },
      // Fee_id 
      fee_id: {
        type: "number",
        title: t("fee_id"),
      },
      gender: {
        type: "string",
        title: t("gender"),
      },
      feed: {
        type: ["string", "null"],
        title: t("feed"),
      },
      // Eat:
      eat: {
        type: ["number", "null"],
        title: t("eat"),
      },
      // Eat quantity
      eat_quantity: {
        type: ["number", "null"],
        title: t("eat_quantity"),
      },
      // Disease
      disease: {
        type: ["string", "null"],
        title: t("disease"),
      },
      // Passport
      passport: {
        type: "string",
        title: t("passport"),
      },
      // Microchip
      microchip: {
        type: "string",
        title: t("microchip"),
      },
      // Description
      description: {
        type: ["string", "null"],
        title: t("description"),
      },
      // Observations
      observations: {
        type: ["string", "null"],
        title: t("observations"),
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    gender: {
      "ui:widget": "gender-selector",
    },
    "customer_id": {
      "ui:widget": "customer-selector",
    },
    "fee_id": {
      "ui:widget": "fee-selector",
    },
    "description": {
      "ui:widget": "textarea",
    },
    "observations": {
      "ui:widget": "textarea"
    },
    colsSchema: [
      [
        {
          name: "customer_id",
          cols: "col-12",
        },
        {
          name: "name",
          cols: "col-6",
        },
        {
          name: "breed",
          cols: "col-6",
        },
      ],
      [
        {
          name: "fee_id",
          cols: "col-6",
        },
        {
          name: "gender",
          cols: "col-6",
        },
        {
          name: "feed",
          cols: "col-12",
        },
        {
          name: "eat",
          cols: "col-6",
        },
        {
          name: "eat_quantity",
          cols: "col-6",
        },
        {
          name: "disease",
          cols: "col-12",
        },
        {
          name: "passport",
          cols: "col-6",
        },
        {
          name: "microchip",
          cols: "col-6",
        },
        {
          name: "description",
          cols: "col-12"
        },
        {
          name: "observations",
          cols: "col-12"
        }
      ]
    ],
  },
  formWidgets: {
    "customer-selector": CustomerSelector,
    "fee-selector": FeeSelector,
    "gender-selector": GenderSelector,
  }
};
export default config;
